// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  domain: 'ibroker-states.web.app',
  googleMapApiKey: 'AIzaSyDkaZS7nvZAEEYWtjO4SmVkMIzG-X7jK90',
  firebase: {
    apiKey: "AIzaSyB517LikCmiVTtusSw0HW-JMW6jdE-dJeY",
    authDomain: "ibroker-states.firebaseapp.com",
    projectId: "ibroker-states",
    storageBucket: "ibroker-states.appspot.com",
    messagingSenderId: "815341578636",
    appId: "1:815341578636:web:07d241b3b97acdf2f90ea9",
    measurementId: "G-QDWWYK7TKW"
  },

  special: [
    { text: 'oneweek'},
    { text: 'twoweeks'},
    { text: 'fourweeks'}
  ],

  special1: [
    { text: 'oneweek'},
    { text: 'twoweeks'},
    { text: 'fourweeks'}
  ],


  offerType: [
    { text: 'apartment', color: '#B21E35' },
    { text: 'villa', color: '#0077B6' },
    { text: 'house', color: '#007F5F' },
    { text: 'land', color: '#99621E' },
    { text: 'real_estate', color: '#2EC4B6' }
  ],

  landSubTypes: [
    { text: 'residential' },
    { text: 'commercial' },
    { text: 'farm' },
    { text: 'industrial' },
    { text: 'mixed_use' },
  ],

  estateSubTypes: [
    { text: 'office' },
    { text: 'shop' },
    { text: 'supermarket' },
    { text: 'showroom' },
    { text: 'complex' },
    { text: 'hotel' },
    { text: 'factory' },
    { text: 'clinic' },
    { text: 'pharmacy' },
    { text: 'warehouse' },
    { text: 'restaurant' },
    { text: 'cafe' }
  ],

  offerFor: [
    { text: 'sale' },
    { text: 'rent' },
    { text: 'sale/rent' }
  ],

  offerUploader: [
    { text: 'owner' },
    { text: 'broker' },
  ],

  distanceUnits: [
    { text: 'm2' },
    { text: 'f2' },
    { text: 'feddan' },
    { text: 'donum' },
    { text: 'hectare' }
  ],

  styles: {
    hybridWithLabels: [
      {
        "featureType": "all",
        "elementType": "labels",
        "stylers": [
          { "visibility": "off" }
        ]
      },
      {
        "featureType": "road.local",
        "elementType": "geometry.stroke",
        "stylers": [
          { "visibility": "off" }
        ]
      },
      {
        "featureType": "administrative.country",
        "elementType": "labels",
        "stylers": [
          { "visibility": "on" }
        ]
      }, {
        "featureType": "administrative.province",
        "elementType": "labels",
        "stylers": [
          { "visibility": "on" }
        ]
      },
      {
        "featureType": "administrative.locality",
        "elementType": "labels",
        "stylers": [
          { "visibility": "on" }
        ]
      },
      {
        "featureType": "administrative",
        "elementType": "geometry",
        "stylers": [
          { "weight": "2" }
        ]
      }, {
        "featureType": "administrative.country",
        "elementType": "geometry.stroke",
        "stylers": [
          { "color": "#FFFFFF" }
        ]
      }, {
        "featureType": "administrative.province",
        "elementType": "geometry.stroke",
        "stylers": [
          { "color": "#FFFFFF" }
        ]
      }
    ],
    hybridWithOUTLabels: [
      {
        "featureType": "all",
        "elementType": "labels",
        "stylers": [
          { "visibility": "off" }
        ]
      },
      {
        "featureType": "road.local",
        "elementType": "geometry.fill",
        "stylers": [
          { "visibility": "off" }
        ]
      },
      {
        "featureType": "road.local",
        "elementType": "geometry.stroke",
        "stylers": [
          { "visibility": "off" }
        ]
      },
      {
        "featureType": "administrative",
        "elementType": "geometry",
        "stylers": [
          { "weight": "2" }
        ]
      }, {
        "featureType": "administrative.country",
        "elementType": "geometry.stroke",
        stylers: [
          { "color": "#FFFFFF" }
        ]
      }, {
        "featureType": "administrative.province",
        "elementType": "geometry.stroke",
        "stylers": [
          { "color": "#FFFFFF" }
        ]
      }
    ],
    roadmapWithLabels: [
      {
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#ebe3cd"
          }
        ]
      },
      {
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#523735"
          }
        ]
      },
      {
        "elementType": "labels.text.stroke",
        "stylers": [
          {
            "color": "#f5f1e6"
          }
        ]
      },
      {
        "featureType": "administrative",
        "elementType": "geometry",
        "stylers": [
          {
            "visibility": "on"
          }
        ]
      },
      {
        "featureType": "administrative.country",
        "elementType": "geometry.stroke",
        "stylers": [
          { "color": "#FFFFFF" }
        ]
      },
      {
        "featureType": "administrative.province",
        "elementType": "geometry.stroke",
        "stylers": [
          { "color": "#FFFFFF" }, {
            "weight": 2
          }
        ]
      },
      {
        "featureType": "administrative",
        "elementType": "geometry.stroke",
        "stylers": [
          {
            "color": "#c9b2a6"
          }
        ]
      },
      {
        "featureType": "administrative.land_parcel",
        "elementType": "geometry.stroke",
        "stylers": [
          {
            "color": "#dcd2be"
          }
        ]
      },
      {
        "featureType": "administrative.land_parcel",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#ae9e90"
          }
        ]
      },
      {
        "featureType": "landscape.natural",
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#dfd2ae"
          }
        ]
      },
      {
        "featureType": "poi",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "featureType": "poi",
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#dfd2ae"
          }
        ]
      },
      {
        "featureType": "poi",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#93817c"
          }
        ]
      },
      {
        "featureType": "poi.park",
        "elementType": "geometry.fill",
        "stylers": [
          {
            "color": "#a5b076"
          }
        ]
      },
      {
        "featureType": "poi.park",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#447530"
          }
        ]
      },
      {
        "featureType": "road",
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#f5f1e6"
          }
        ]
      },
      {
        "featureType": "road",
        "elementType": "labels.icon",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "featureType": "road.arterial",
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#fdfcf8"
          }
        ]
      },
      {
        "featureType": "road.highway",
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#f8c967"
          }
        ]
      },
      {
        "featureType": "road.highway",
        "elementType": "geometry.stroke",
        "stylers": [
          {
            "color": "#e9bc62"
          }
        ]
      },
      {
        "featureType": "road.highway.controlled_access",
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#e98d58"
          }
        ]
      },
      {
        "featureType": "road.highway.controlled_access",
        "elementType": "geometry.stroke",
        "stylers": [
          {
            "color": "#db8555"
          }
        ]
      },
      {
        "featureType": "road.local",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#806b63"
          }
        ]
      },
      {
        "featureType": "transit",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "featureType": "transit.line",
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#dfd2ae"
          }
        ]
      },
      {
        "featureType": "transit.line",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#8f7d77"
          }
        ]
      },
      {
        "featureType": "transit.line",
        "elementType": "labels.text.stroke",
        "stylers": [
          {
            "color": "#ebe3cd"
          }
        ]
      },
      {
        "featureType": "transit.station",
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#dfd2ae"
          }
        ]
      },
      {
        "featureType": "water",
        "elementType": "geometry.fill",
        "stylers": [
          {
            "color": "#b9d3c2"
          }
        ]
      },
      {
        "featureType": "water",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#92998d"
          }
        ]
      }
    ],
    roadmapWithOUTLabels: [
      {
        "featureType": "all",
        "elementType": "labels",
        "stylers": [
          { "visibility": "off" }
        ]
      },
      {
        "featureType": "road.local",
        "elementType": "geometry.fill",
        "stylers": [
          { "visibility": "on" }
        ]
      },
      {
        "featureType": "road.local",
        "elementType": "geometry.stroke",
        "stylers": [
          { "visibility": "on" }
        ]
      },
      {
        "featureType": "administrative.country",
        "elementType": "geometry.stroke",
        "stylers": [
          {
            "color": "#FFFFFF"
          },
          {
            "weight": 2
          }
        ]
      }, {
        "featureType": "administrative.province",
        "elementType": "geometry.stroke",
        "stylers": [
          { "color": "#FFFFFF" },
          {
            "weight": 2
          }
        ]
      },
      {
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#ebe3cd"
          }
        ]
      },
      {
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#523735"
          }
        ]
      },
      {
        "elementType": "labels.text.stroke",
        "stylers": [
          {
            "color": "#f5f1e6"
          }
        ]
      },
      {
        "featureType": "administrative",
        "elementType": "geometry",
        "stylers": [
          {
            "visibility": "on"
          }
        ]
      },
      {
        "featureType": "administrative",
        "elementType": "geometry.stroke",
        "stylers": [
          {
            "color": "#c9b2a6"
          }
        ]
      },
      {
        "featureType": "administrative.land_parcel",
        "elementType": "geometry.stroke",
        "stylers": [
          {
            "color": "#dcd2be"
          }
        ]
      },
      {
        "featureType": "administrative.land_parcel",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#ae9e90"
          }
        ]
      },
      {
        "featureType": "landscape.natural",
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#dfd2ae"
          }
        ]
      },
      {
        "featureType": "poi",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "featureType": "poi",
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#dfd2ae"
          }
        ]
      },
      {
        "featureType": "poi",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#93817c"
          }
        ]
      },
      {
        "featureType": "poi.park",
        "elementType": "geometry.fill",
        "stylers": [
          {
            "color": "#a5b076"
          }
        ]
      },
      {
        "featureType": "poi.park",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#447530"
          }
        ]
      },
      {
        "featureType": "road",
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#f5f1e6"
          }
        ]
      },
      {
        "featureType": "road",
        "elementType": "labels.icon",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "featureType": "road.arterial",
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#fdfcf8"
          }
        ]
      },
      {
        "featureType": "road.highway",
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#f8c967"
          }
        ]
      },
      {
        "featureType": "road.highway",
        "elementType": "geometry.stroke",
        "stylers": [
          {
            "color": "#e9bc62"
          }
        ]
      },
      {
        "featureType": "road.highway.controlled_access",
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#e98d58"
          }
        ]
      },
      {
        "featureType": "road.highway.controlled_access",
        "elementType": "geometry.stroke",
        "stylers": [
          {
            "color": "#db8555"
          }
        ]
      },
      {
        "featureType": "road.local",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#806b63"
          }
        ]
      },
      {
        "featureType": "transit",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "featureType": "transit.line",
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#dfd2ae"
          }
        ]
      },
      {
        "featureType": "transit.line",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#8f7d77"
          }
        ]
      },
      {
        "featureType": "transit.line",
        "elementType": "labels.text.stroke",
        "stylers": [
          {
            "color": "#ebe3cd"
          }
        ]
      },
      {
        "featureType": "transit.station",
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#dfd2ae"
          }
        ]
      },
      {
        "featureType": "water",
        "elementType": "geometry.fill",
        "stylers": [
          {
            "color": "#b9d3c2"
          }
        ]
      },
      {
        "featureType": "water",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#92998d"
          }
        ]
      }
    ],
    roadmapWithOUTLabels_2: [
      {
        "featureType": "all",
        "elementType": "labels",
        "stylers": [
          { "visibility": "off" }
        ]
      },
      {
        "featureType": "poi",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "featureType": "road",
        "elementType": "labels.icon",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "featureType": "transit",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      }
    ],
    roadmapWithLabels_2: [
      {
        "featureType": "all",
        "elementType": "labels",
        "stylers": [
          { "visibility": "on" }
        ]
      },
      {
        "featureType": "poi",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "featureType": "road",
        "elementType": "labels.icon",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "featureType": "transit",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      }
    ],

    roadmapWithOUTLabels_3: [
      {
        "featureType": "administrative",
        "elementType": "geometry",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "featureType": "administrative",
        "elementType": "labels",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "featureType": "administrative.country",
        "stylers": [
          {
            "visibility": "on"
          },
          {
            "weight": 1.5
          }
        ]
      },
      {
        "featureType": "administrative.country",
        "elementType": "labels",
        "stylers": [
          {
            "color": "#000000"
          },
          {
            "visibility": "off"
          }
        ]
      },
      {
        "featureType": "administrative.country",
        "elementType": "labels.text",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "featureType": "administrative.land_parcel",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "featureType": "administrative.locality",
        "stylers": [
          {
            "visibility": "simplified"
          }
        ]
      },
      {
        "featureType": "administrative.locality",
        "elementType": "labels",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "featureType": "administrative.neighborhood",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "featureType": "administrative.province",
        "stylers": [
          {
            "color": "#707070"
          },
          {
            "visibility": "on"
          },
          {
            "weight": 1.5
          }
        ]
      },
      {
        "featureType": "administrative.province",
        "elementType": "labels",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "featureType": "administrative.province",
        "elementType": "labels.text",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "featureType": "landscape.man_made",
        "stylers": [
          {
            "lightness": 5
          },
          {
            "visibility": "off"
          },
          {
            "weight": 1
          }
        ]
      },
      {
        "featureType": "landscape.natural",
        "stylers": [
          {
            "visibility": "on"
          }
        ]
      },
      {
        "featureType": "landscape.natural",
        "elementType": "labels",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "featureType": "poi",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "featureType": "poi",
        "elementType": "labels",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "featureType": "road",
        "elementType": "labels",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "featureType": "road",
        "elementType": "labels.icon",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "featureType": "road.arterial",
        "stylers": [
          {
            "color": "#d6d6d6"
          }
        ]
      },
      {
        "featureType": "road.arterial",
        "elementType": "labels.text",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "featureType": "road.highway",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "featureType": "road.highway",
        "elementType": "geometry",
        "stylers": [
          {
            "visibility": "on"
          },
          {
            "weight": 0.5
          }
        ]
      },
      {
        "featureType": "road.highway",
        "elementType": "labels.text",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "featureType": "road.highway.controlled_access",
        "elementType": "labels.text",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "featureType": "road.local",
        "stylers": [
          {
            "visibility": "on"
          }
        ]
      },
      {
        "featureType": "road.local",
        "elementType": "labels.text",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "featureType": "transit",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "featureType": "water",
        "stylers": [
          {
            "saturation": -40
          }
        ]
      },
      {
        "featureType": "water",
        "elementType": "labels.text",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      }
    ],
    roadmapWithLabels_3:[
      {
        "featureType": "administrative",
        "elementType": "geometry",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "featureType": "administrative.country",
        "stylers": [
          {
            "color": "#707070"
          },
          {
            "visibility": "on"
          },
          {
            "weight": 1.5
          }
        ]
      },
      {
        "featureType": "administrative.country",
        "elementType": "labels",
        "stylers": [
          {
            "color": "#000000"
          },
          {
            "visibility": "simplified"
          }
        ]
      },
      {
        "featureType": "administrative.locality",
        "stylers": [
          {
            "visibility": "simplified"
          }
        ]
      },
      {
        "featureType": "administrative.neighborhood",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "featureType": "administrative.province",
        "stylers": [
          {
            "color": "#707070"
          },
          {
            "visibility": "on"
          },
          {
            "weight": 1.5
          }
        ]
      },
      {
        "featureType": "administrative.province",
        "elementType": "labels",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "featureType": "landscape.man_made",
        "stylers": [
          {
            "lightness": 5
          },
          {
            "visibility": "off"
          },
          {
            "weight": 1
          }
        ]
      },
      {
        "featureType": "landscape.natural",
        "stylers": [
          {
            "visibility": "on"
          }
        ]
      },
      {
        "featureType": "landscape.natural",
        "elementType": "labels",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "featureType": "poi",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "featureType": "road",
        "elementType": "labels",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "featureType": "road",
        "elementType": "labels.icon",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "featureType": "road.arterial",
        "stylers": [
          {
            "color": "#d6d6d6"
          }
        ]
      },
      {
        "featureType": "road.arterial",
        "elementType": "labels.text",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "featureType": "road.highway",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "featureType": "road.highway",
        "elementType": "geometry",
        "stylers": [
          {
            "visibility": "on"
          },
          {
            "weight": 0.5
          }
        ]
      },
      {
        "featureType": "road.highway",
        "elementType": "labels.text",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "featureType": "road.highway.controlled_access",
        "elementType": "labels.text",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "featureType": "road.local",
        "stylers": [
          {
            "visibility": "on"
          }
        ]
      },
      {
        "featureType": "road.local",
        "elementType": "labels.text",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "featureType": "transit",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "featureType": "water",
        "stylers": [
          {
            "saturation": -40
          }
        ]
      },
      {
        "featureType": "water",
        "elementType": "labels.text",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      }
    ]
  },


  countries: [
    {
      name: "Oman",
      location: { lat: 21.450661604068202, lng: 57.08061022456168 },
      currency: 'OMR',
      code: '+968',
      flag: 'oman',
      childrens: [
        {
          name: "Muscat",
          location: { lat: 23.589360699080444, lng: 58.34682636281036},
          childrens: [
            {
              name: "Al_Amarat",
              location: { lat: 23.503260429194967, lng: 58.48634285801144}
            },
            {
              name: "Bawshar",
              location: { lat: 23.564242, lng: 58.416972 }
            },
            {
              name: "subMuscat",
              location: { lat: 23.567029, lng: 58.272759 },
            },
            {
              name: "Muttrah",
              location: { lat: 23.608553706835455, lng: 58.543065988288944}
            },
            {
              name: "Qurayyat",
              location: { lat: 23.265263, lng: 58.910719 }
            },
            {
              name: "Al_Seeb",
              location: { lat: 23.608843583979773, lng: 58.181140380493645}
            }
          ]
        },
        {
          name: "Musandam",
          location: { lat: 25.96578151185641, lng: 56.27205552987516 },
          childrens: [
            {
              name: "Khasab",
              location: { lat: 26.186927, lng: 56.247183 }
            },
            {
              name: "Bukha",
              location: { lat: 26.141853, lng: 56.148419 }
            },
            {
              name: "Dibba_Al_Bayah",
              location: { lat: 25.647206, lng: 56.261557 }
            },
            {
              name: "Madha",
              location: { lat: 25.289034, lng: 56.338856 }
            }
          ]
        },
        {
          name: "Dhofar",
          location: { lat: 17.2265295507936, lng: 54.10247586029089},
          childrens: [
            {
              name: "AlـMazyūnah",
              location: { lat: 17.837734, lng: 52.658850 }
            },
            {
              name: "Ḍalkut",
              location: { lat: 16.716659, lng: 53.209660 }
            },
            {
              name: "Mirbat",
              location: { lat: 16.986875, lng: 54.701039 }
            },
            {
              name: "Muqshin",
              location: { lat: 19.564507, lng: 54.885777 }
            },
            {
              name: "Rakhyut",
              location: { lat: 16.748968, lng: 53.420012 }
            },
            {
              name: "Sadah",
              location: { lat: 17.054795, lng: 55.068412 }
            },
            {
              name: "Salalah",
              location: { lat: 17.049668, lng: 54.109333 }
            },
            {
              name: "ShalimـandـtheـHallaniyatـIslands",
              location: { lat: 17.512434, lng: 56.016887 }
            },
            {
              name: "Taqah",
              location: { lat: 17.054516, lng: 54.391967 }
            },
            {
              name: "Thumrait",
              location: { lat: 17.644319, lng: 54.026504 }
            }
          ]
        },
        {
          name: "Sharqiyah_South",
          location: { lat: 22.337478509984958, lng: 59.40175856038952},
          childrens: [
            {
              name: "Sur",
              location: { lat: 22.553558, lng: 59.495432 }
            },
            {
              name: "Al_Kamil_Al_Wafi",
              location: { lat: 22.202596, lng: 59.212602 }
            },
            {
              name: "Jalan_Bani_Bu_Hassan",
              location: { lat: 22.084556, lng: 59.280036 }
            },
            {
              name: "Jalan_Bani_Bu_Ali",
              location: { lat: 22.007486, lng: 59.333982 }
            },
            {
              name: "Masirah",
              location: { lat: 20.388553, lng: 58.771240 }
            }
          ]
        },
        {
          name: "Sharqiyah_North",
          location: { lat: 22.493145747607766, lng: 58.51188507940007 },
          childrens: [
            {
              name: "Al_Qabil",
              location: { lat: 22.580200638298976, lng: 58.685993915341754 }
            },
            {
              name: "Al_Mudhaibi",
              location: { lat: 22.571833, lng: 58.123249 }
            },
            {
              name: "Bidiya",
              location: { lat: 22.442114, lng: 58.806627 }
            },
            {
              name: "Dema_Wa_Thaieen",
              location: { lat: 23.050025, lng: 58.482506 }
            },
            {
              name: "Ibra",
              location: { lat: 22.730437, lng: 58.526245 }
            },
            {
              name: "Wadi_Bani_Khalid",
              location: { lat: 22.585278, lng: 59.090005 }
            }
          ]
        },
        {
          name: "Al_Wusta",
          location: { lat: 19.525129826959493, lng: 57.558663018736524},
          childrens: [
            {
              name: "Haima",
              location: { lat: 19.955716, lng: 56.283580 }
            },
            {
              name: "Duqm",
              location: { lat: 19.648014, lng: 57.682887 }
            },
            {
              name: "Mahout",
              location: { lat: 20.723254, lng: 58.188004 }
            },
            {
              name: "Al_Jazer",
              location: { lat: 19.568951087532, lng: 57.67753094160412}
            }
          ]
        },
        {
          name: "Dakhiliyah",
          location: { lat: 22.874497461348128, lng: 57.55822774604316},
          childrens: [
            {
              name: "Nizwa",
              location: { lat: 22.926316, lng: 57.524988 }
            },
            {
              name: "Samail",
              location: { lat: 23.298820, lng: 57.982861 }
            },
            {
              name: "Bahla",
              location: { lat: 22.945146, lng: 57.285257 }
            },
            {
              name: "Adam",
              location: { lat: 22.383766, lng: 57.526688 }
            },
            {
              name: "Al_Hamra",
              location: { lat: 23.100832, lng: 57.294947 }
            },
            {
              name: "Manah",
              location: { lat: 22.795757, lng: 57.599926 }
            },
            {
              name: "Izki",
              location: { lat: 22.932220, lng: 57.765979 }
            },
            {
              name: "Bid_Bid",
              location: { lat: 23.405919, lng: 58.125013 }
            }
          ]
        },
        {
          name: "Dhahirah",
          location: { lat: 23.397045031918967, lng: 56.46254957483355},
          childrens: [
            {
              name: "Ibri",
              location: { lat: 23.211111, lng: 56.477449 }
            },
            {
              name: "Yanqul",
              location: { lat: 23.598428, lng: 56.552901 }
            },
            {
              name: "Dhank",
              location: { lat: 23.542287, lng: 56.257660 }
            }
          ]
        },
        {
          name: "Batinah_North",
          location: { lat: 24.196464555486735, lng: 56.84322798960312},
          childrens: [
            {
              name: "Sohar",
              location: { lat: 24.353790, lng: 56.739765 }
            },
            {
              name: "Shinas",
              location: { lat: 24.732549, lng: 56.462768 }
            },
            {
              name: "Liwa",
              location: { lat: 24.505484, lng: 56.585574 }
            },
            {
              name: "Saham",
              location: { lat: 24.168319, lng: 56.877808 }
            },
            {
              name: "Al_Khaboura",
              location: { lat: 23.962425, lng: 57.113502 }
            },
            {
              name: "Suwayq",
              location: { lat: 23.837258, lng: 57.440796 }
            }
          ]
        },
        {
          name: "Batinah_South",
          location: { lat: 23.55032934815974, lng: 57.59711417447163 },
          childrens: [
            {
              name: "Rustaq",
              location: { lat: 23.426708, lng: 57.432477 }
            },
            {
              name: "Al_Awabi",
              location: { lat: 23.310798, lng: 57.540011 }
            },
            {
              name: "Nakhal",
              location: { lat: 23.394230, lng: 57.824574 }
            },
            {
              name: "Wadi_Al_Maawil",
              location: { lat: 23.478164, lng: 57.837099 }
            },
            {
              name: "Barka",
              location: { lat: 23.697978, lng: 57.888109 }
            },
            {
              name: "Al_Musannah",
              location: { lat: 23.769138, lng: 57.640541 }
            }
          ]
        },
        {
          name: "Buraimi",
          location: { lat: 24.323601793150917, lng: 56.053671599462746 },
          childrens: [
            {
              name: "subBuraimi",
              location: { lat: 24.264831, lng: 55.824236 }
            },
            {
              name: "Mohadah",
              location: { lat: 24.403046, lng: 55.963659 }
            },
            {
              name: "Alsinina",
              location: { lat: 23.611641, lng: 55.966072 }
            }
          ]
        }
      ]
    }
  ],

  specialOfferExampleEn: {
    id: '123',
    uid: '123',
    title: 'New appartement for sale',
    short_title: 'new appartement for sale',
    cover: 'https://firebasestorage.googleapis.com/v0/b/ibroker-states.appspot.com/o/special_imgs%2F1662493031873_1662493016603.jpeg?alt=media&token=0275d3f1-4f9c-4bdb-8be5-d560a0aeb140',
    description: 'Appartement consist of two bedroom, one livingroom and mini kitchen with total area 120 m2 ready for living.',
    oFor: 'sale',
    oType: 'apartment',
    oUploader: 'owner',
    imgsUrl: [],
    price: {
      value: 0,
      currency: 'OMR'
    },
    date: new Date('Tue Jul 26 2022 12:31:56 GMT+0400 (Gulf Standard Time)'),
    status: {
      value: true,
      expired_date: {
        nanoseconds: 409000000,
        seconds: 1669750634
      }
    },
    views: 83,
    coordinates: {
      _lat: 23.5880307,
      _long: 58.3828717
    },
    address: {
      country: "Oman",
      place: "Almaabila",
      region: "Al_Seeb",
      state: "Muscat"
    },
    isSpecial: {
      value: true,
      expired_date: {
        nanoseconds: 409000000,
        seconds: 1669750634
      }
    },

  },

  specialOfferExampleAr: {
    id: '123',
    uid: '123',
    title: 'شقة جديدة للبيع',
    short_title: 'شقة جديدة للبيع',
    cover: 'https://firebasestorage.googleapis.com/v0/b/ibroker-states.appspot.com/o/special_imgs%2F1662493031873_1662493016603.jpeg?alt=media&token=0275d3f1-4f9c-4bdb-8be5-d560a0aeb140',
    description: 'شقة تتكون من غرفتين معيشة وصالة ومطبخ مصغر بمساحة إجمالية ١٢٠ متر مربع جاهزة لتسليم.',
    oFor: 'sale',
    oType: 'apartment',
    oUploader: 'owner',
    imgsUrl: [],
    price: {
      value: 0,
      currency: 'OMR'
    },
    date: new Date('Tue Jul 26 2022 12:31:56 GMT+0400 (Gulf Standard Time)'),
    status: {
      value: true,
      expired_date: {
        nanoseconds: 409000000,
        seconds: 1669750634
      }
    },
    views: 83,
    coordinates: {
      _lat: 23.5880307,
      _long: 58.3828717
    },
    address: {
      country: "Oman",
      place: "معبيلة",
      region: "Al_Seeb",
      state: "Muscat"
    },
    isSpecial: {
      value: true,
      expired_date: {
        nanoseconds: 409000000,
        seconds: 1669750634
      }
    },

  },

  agencyAccountEn: {
    uid: '123',
    name: 'User',
    short_name: 'user',
    registration_date: 'Tue Jul 26 2022 12:31:56 GMT+0400 (Gulf Standard Time)',
    type: {
      value: 'office',
      pakege: 'gold',
      avilable_offers: 3,
      expired_date: new Date('Tue Jul 26 2022 12:31:56 GMT+0400 (Gulf Standard Time)'),
      order_id: '123'
    },
    status: 'active',
    login_method: '',
    num_offers: 12,
    img_url: null,
    bio: 'I started my online real estate agency',
    email: 'user email',
    phone: 'user phone',
    phone2: 'user phone',
    coordinates: ''
  },
  agencyAccountAr: {
    uid: '123',
    name: 'User',
    short_name: 'user',
    registration_date: 'Tue Jul 26 2022 12:31:56 GMT+0400 (Gulf Standard Time)',
    type: {
      value: 'office',
      pakege: 'gold',
      avilable_offers: 3,
      expired_date: new Date('Tue Jul 26 2022 12:31:56 GMT+0400 (Gulf Standard Time)'),
      order_id: '123'
    },
    status: 'active',
    login_method: '',
    num_offers: 12,
    img_url: null,
    bio: 'I started my online real estate agency',
    email: '',
    phone: '',
    phone2: '',
    coordinates: ''
  }

};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.


/* UAE

    {
      name: "UAE",
      childrens: [
        {
          name: "Abu_Dhabi",
          childrens: [
            { name: "subAbu_Dhabi" },
            { name: "Al_Dhafra" },
            { name: "Al_Ain" },
            { name: "Al_Ajban" },
            { name: "Al_Tawelah" },
            { name: "Al_Shalelah" },
            { name: "Al_Shamkha" },
            { name: "Al_Wahda" },
            { name: "Al_Mu'azaz" },
            { name: "Al_Adla" },
            { name: "Marabe_al_Dhafra" }
          ]
        },
        {
          name: "Ajman",
          childrens: [
            { name: "subAjman" },
            { name: "Masfout" },
            { name: "Al_Manama" }
          ]
        },
        {
          name: "Dubai",
          childrens: [
            { name: "subDubai" },
            { name: "Jebel_Ali" },
            { name: "Hatta" },
            { name: "Al_Awir" },
            { name: "Al_Lisaili" }
          ]
        },
        {
          name: "Fujairah",
          childrens: [
            { name: "" },
            { name: "" },
            { name: "" }
          ]
        },
        {
          name: "Ras_al-Khaimah",
          childrens: [
            { name: "subRas_Al_Khaimah" },
            { name: "Al_Jazirah_Al_Hamra" },
            { name: "Rams" },
            { name: "Khor_Khwair" },
            { name: "Diqdaqah" },
            { name: "Khatt" },
            { name: "Masafi" },
            { name: "Huwaylat" }

          ]
        },
        {
          name: "Sharjah",
          childrens: [
            { name: "" },
            { name: "" },
            { name: "" }
          ]
        },
        {
          name: "Umm al-Quwain",
          childrens: [
            { name: "" },
            { name: "" },
            { name: "" }
          ]
        }
      ]
    }
*/



/* Saudi arabia
{
name: "Saudi_Arabia",
location: { lat: , lng:  },
childrens: [
  {
    name: "Mecca_Region",
    location: { lat: , lng:  },
    childrens: [
      {
        name: "Jeddah",
        location: { lat:  lng: }
      },{
        name: "Mecca",
        location: { lat:  lng: }
      },{
        name: "Taif",
        location: { lat:  lng: }
      },{
        name: "Qunfudhah",
        location: { lat:  lng: }
      },{
        name: "Laith",
        location: { lat:  lng: }
      },{
        name: "Jumum",
        location: { lat:  lng: }
      },{
        name: "Rabigh",
        location: { lat:  lng: }
      },{
        name: "Khulays",
        location: { lat:  lng: }
      },{
        name: "Ranyah",
        location: { lat:  lng: }
      },{
        name: "Turbah",
        location: { lat:  lng: }
      },{
        name: "Khurmah",
        location: { lat:  lng: }
      },{
        name: "Kamil",
        location: { lat:  lng: }
      }
    ]
  },
  {
    name: "Riyadh_Region",
    location: { lat: , lng:  },
    childrens: [
      {
        name: "Al_Deriyya",
        location: { lat:  lng: }
      },{
        name: "Al_Kharj ",
        location: { lat:  lng: }
      },{
        name: "Al_Dawadmy",
        location: { lat:  lng: }
      },{
        name: "Al_Majmaah",
        location: { lat:  lng: }
      },{
        name: "Al_Quwayiyah",
        location: { lat:  lng: }
      },{
        name: "Wadi Al-Dawaser",
        location: { lat:  lng: }
      },{
        name: "Al_Aflaj",
        location: { lat:  lng: }
      },{
        name: "Al_Zulfi",
        location: { lat:  lng: }
      },{
        name: "Shaqra",
        location: { lat:  lng: }
      },{
        name: "Hotat_Bani_Tameem",
        location: { lat:  lng: }
      },{
        name: "Afeef",
        location: { lat:  lng: }
      },{
        name: "Al_Saleel",
        location: { lat:  lng: }
      },{
        name: "Dharma",
        location: { lat:  lng: }
      },{
        name: "Al_Muzahmeya",
        location: { lat:  lng: }
      },{
        name: "Rumah",
        location: { lat:  lng: }
      },{
        name: "Thadig",
        location: { lat:  lng: }
      },{
        name: "Hraymla",
        location: { lat:  lng: }
      },{
        name: "Al_Hareeq",
        location: { lat:  lng: }
      },{
        name: "Al_Ghat",
        location: { lat:  lng: }
      }
    ]
  },{
    name: "Medina_Region",
    location: { lat: , lng:  },
    childrens: [
      {
        name: "Medina",
        location: { lat:  lng: }
      },{
        name: "Al_Hanakia",
        location: { lat:  lng: }
      },{
        name: "Al_Mahd ",
        location: { lat:  lng: }
      },{
        name: "Al_Ulaa",
        location: { lat:  lng: }
      },{
        name: "Badr",
        location: { lat:  lng: }
      },{
        name: "Yanbu",
        location: { lat:  lng: }
      },{
        name: "Khaibar",
        location: { lat:  lng: }
      }
    ]
  },
  {
    name: "Eastern_Region",
    location: { lat: , lng:  },
    childrens: [
      {
        name: "Ahsa",
        location: { lat:  lng: }
      },{
        name: "Dammam",
        location: { lat:  lng: }
      },{
        name: "Khobar",
        location: { lat:  lng: }
      },{
        name: "Qatif",
        location: { lat:  lng: }
      },{
        name: "Hafr_Al_Batin  ",
        location: { lat:  lng: }
      },{
        name: "Jubail",
        location: { lat:  lng: }
      },{
        name: "Dhahran",
        location: { lat:  lng: }
      },{
        name: "Khafji",
        location: { lat:  lng: }
      },{
        name: "Ras_Tanura",
        location: { lat:  lng: }
      },{
        name: "Abqaiq",
        location: { lat:  lng: }
      },{
        name: "Nairiyah",
        location: { lat:  lng: }
      },{
        name: "Qaryat_Al_Ulya",
        location: { lat:  lng: }
      }
    ]
  },  {
    name: "Aseer_Region",
    location: { lat: , lng:  },
    childrens: [
      {
        name: "Abha",
        location: { lat:  lng: }
      },{
        name: "Khamis_Mushait",
        location: { lat:  lng: }
      },{
        name: "Bishah",
        location: { lat:  lng: }
      },{
        name: "Al_Nammas",
        location: { lat:  lng: }
      },{
        name: "Mahael_Asseer",
        location: { lat:  lng: }
      },{
        name: "Rejal_Almaa",
        location: { lat:  lng: }
      },{
        name: "Al_Majardah",
        location: { lat:  lng: }
      },{
        name: "Surat_Ubayda",
        location: { lat:  lng: }
      },{
        name: "Ohud_Rafidah",
        location: { lat:  lng: }
      },{
        name: "Belgarn",
        location: { lat:  lng: }
      },{
        name: "Tathleith",
        location: { lat:  lng: }
      },{
        name: "Dhahran_Al_Janoub",
        location: { lat:  lng: }
      }
    ]
  },  {
    name: "Jazan_Region",
    location: { lat: , lng:  },
    childrens: [
      {
        name: "Abu_Arish",
        location: { lat:  lng: }
      },{
        name: "Alddair",
        location: { lat:  lng: }
      },{
        name: "Alddarb",
        location: { lat:  lng: }
      },{
        name: "Ahad Almasarihah",
        location: { lat:  lng: }
      },{
        name: "Alaridah",
        location: { lat:  lng: }
      },{
        name: "Alaydabi",
        location: { lat:  lng: }
      },{
        name: "Alharth",
        location: { lat:  lng: }
      },{
        name: "Alraith",
        location: { lat:  lng: }
      },{
        name: "Baish",
        location: { lat:  lng: }
      },{
        name: "Damad",
        location: { lat:  lng: }
      },{
        name: "Farasan",
        location: { lat:  lng: }
      },{
        name: "Jazan",
        location: { lat:  lng: }
      },{
        name: "Sabya",
        location: { lat:  lng: }
      },{
        name: "Samtah",
        location: { lat:  lng: }
      }
    ]
  }, {
    name: "Al_Qassim_Region",
    location: { lat: , lng:  },
    childrens: [
      {
        name: "Onaizah",
        location: { lat:  lng: }
      },{
        name: "Al_Rass",
        location: { lat:  lng: }
      },{
        name: "Al_Maznab",
        location: { lat:  lng: }
      },{
        name: "Al_Bekayriyah",
        location: { lat:  lng: }
      },{
        name: "Al_Badaya",
        location: { lat:  lng: }
      },{
        name: "Al_Asyah",
        location: { lat:  lng: }
      },{
        name: "Al_Nabahaniyah",
        location: { lat:  lng: }
      },{
        name: "Al_Shammasiyah",
        location: { lat:  lng: }
      },{
        name: "Oyoun_Al_Jawah",
        location: { lat:  lng: }
      },{
        name: "Riad_Al_Khubra",
        location: { lat:  lng: }
      }
    ]
  },  {
    name: "Tabuk_Region",
    location: { lat: , lng:  },
    childrens: [
      {
        name: "Al_Wajh",
        location: { lat:  lng: }
      },{
        name: "Deba",
        location: { lat:  lng: }
      },{
        name: "Taima",
        location: { lat:  lng: }
      },{
        name: "Amloj",
        location: { lat:  lng: }
      },{
        name: "Hagl",
        location: { lat:  lng: }
      },{
        name: "Al_Beda’",
        location: { lat:  lng: }
      }
    ]
  },  {
    name: "Hail_Region",
    location: { lat: , lng:  },
    childrens: [
      {
        name: "Baqaa",
        location: { lat:  lng: }
      },{
        name: "Shanan",
        location: { lat:  lng: }
      },{
        name: "Ghazalah",
        location: { lat:  lng: }
      },{
        name: "Hail",
        location: { lat:  lng: }
      },{
        name: "Shamli",
        location: { lat:  lng: }
      },{
        name: "Sulaimi",
        location: { lat:  lng: }
      },{
        name: "Mawqaq",
        location: { lat:  lng: }
      },{
        name: "Sumairah",
        location: { lat:  lng: }
      },{
        name: "Hait",
        location: { lat:  lng: }
      }
    ]
  },  {
    name: "Najran_Region",
    location: { lat: , lng:  },
    childrens: [
      {
        name: "Sharorah",
        location: { lat:  lng: }
      },{
        name: "Habouna",
        location: { lat:  lng: }
      },{
        name: "Thar",
        location: { lat:  lng: }
      },{
        name: "Yedamah",
        location: { lat:  lng: }
      },{
        name: "Badr_Al_Janoub",
        location: { lat:  lng: }
      },{
        name: "Khabbash",
        location: { lat:  lng: }
      },{
        name: "Al_Kharkheer",
        location: { lat:  lng: }
      }
    ]
  },  {
    name: "Al_Jawf_Region",
    location: { lat: , lng:  },
    childrens: [
      {
        name: "Sakaka",
        location: { lat:  lng: }
      },{
        name: "Qurayyat",
        location: { lat:  lng: }
      },{
        name: "Duma_al_Jandal",
        location: { lat:  lng: }
      },{
        name: "Tabarjal",
        location: { lat:  lng: }
      },{
        name: "",
        location: { lat:  lng: }
      },{
        name: "",
        location: { lat:  lng: }
      },{
        name: "",
        location: { lat:  lng: }
      },{
        name: "",
        location: { lat:  lng: }
      },{
        name: "",
        location: { lat:  lng: }
      },{
        name: "",
        location: { lat:  lng: }
      },{
        name: "",
        location: { lat:  lng: }
      },{
        name: "",
        location: { lat:  lng: }
      },{
        name: "",
        location: { lat:  lng: }
      },{
        name: "",
        location: { lat:  lng: }
      },{
        name: "",
        location: { lat:  lng: }
      },{
        name: "",
        location: { lat:  lng: }
      },{
        name: "",
        location: { lat:  lng: }
      },{
        name: "",
        location: { lat:  lng: }
      },{
        name: "",
        location: { lat:  lng: }
      },{
        name: "",
        location: { lat:  lng: }
      },{
        name: "",
        location: { lat:  lng: }
      }
    ]
  },  {
    name: "Al_Bahah_Region",
    location: { lat: , lng:  },
    childrens: [
      {
        name: "",
        location: { lat:  lng: }
      },{
        name: "",
        location: { lat:  lng: }
      },{
        name: "",
        location: { lat:  lng: }
      },{
        name: "",
        location: { lat:  lng: }
      },{
        name: "",
        location: { lat:  lng: }
      },{
        name: "",
        location: { lat:  lng: }
      },{
        name: "",
        location: { lat:  lng: }
      },{
        name: "",
        location: { lat:  lng: }
      },{
        name: "",
        location: { lat:  lng: }
      },{
        name: "",
        location: { lat:  lng: }
      },{
        name: "",
        location: { lat:  lng: }
      },{
        name: "",
        location: { lat:  lng: }
      },{
        name: "",
        location: { lat:  lng: }
      },{
        name: "",
        location: { lat:  lng: }
      },{
        name: "",
        location: { lat:  lng: }
      },{
        name: "",
        location: { lat:  lng: }
      },{
        name: "",
        location: { lat:  lng: }
      },{
        name: "",
        location: { lat:  lng: }
      },{
        name: "",
        location: { lat:  lng: }
      },{
        name: "",
        location: { lat:  lng: }
      },{
        name: "",
        location: { lat:  lng: }
      }
    ]
  },  {
    name: "Northern_Borders_Region",
    location: { lat: , lng:  },
    childrens: [
      {
        name: "Arar",
        location: { lat:  lng: }
      },{
        name: "Rafha",
        location: { lat:  lng: }
      },{
        name: "Turayf",
        location: { lat:  lng: }
      },{
        name: "Al_Uwayqilah",
        location: { lat:  lng: }
      }
    ]
  }
]
}
*/
